module.exports = __webpack_public_path__ + "img/202403_05.42005224.jpg";